import { useLocation } from "react-router-dom";
import { NavItems } from "../../NavItems";

export const Breadcrumbs = () => {
	const location = useLocation();
	console.log(location.pathname);

	const findLableByPath = (items, path) => {
		let matchedLabel = null;

		for (const item of items) {
			if (typeof item.path === "string" && item.path === path) {
				matchedLabel = item.label;
			}
			if (item.submenu) {
				const found = findLableByPath(item.submenu, path);
				if (found) return found;
			}
		}

		return matchedLabel;
	};

	const label = findLableByPath(NavItems, location.pathname);
	console.log(label);

	return (
		<div className="breadcrumbs">
			<nav className="container">
				<span className="breadcrumbs__current">{label}</span>
			</nav>
		</div>
	);
};
